import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from "antd"
import recorded from "../../images/recorded.png";
import noRecord from "../../images/noRecord.png";
import TransferPosition from "./TransferPosition";
import HistoricalRelease from './historicalRelease/historicalRelease';
import BaseComponent from "../../../../base/BaseComponent";
import { getColorByActivityType, getColorByStatus } from "../ColorByStatus";
import { formatToDay } from "../../../../utils";
import GetPosition from "./getPosition";
import "./list.css";
import {message} from "../../../../utils/message";

/**
 * creat by xcc
 * @description 卡片形式
 */
const { Meta } = Card;
export default class PositionCard extends BaseComponent {
    static propTypes = {
        style: PropTypes.object,
        styleOut: PropTypes.object,
        key: PropTypes.string,
    };
    static defaultProps = {
        style: {},
        styleOut: {},
        key: 'PageTemplate'
    };

    constructor(props) {
        super(props);
        this.state = {
            contentWidth: null,
            expandedRows: {},
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.resizeObserver = new ResizeObserver(e => {
            e.forEach(entry => {
                this.setState({
                    contentWidth: entry.contentRect.width
                })
            });
        });
        const target = document.querySelector('.list-card');
        if (target) {
            this.resizeObserver.observe(target);
        }
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            const target = document.querySelector('.list-card');
            if (target) {
                this.resizeObserver.unobserve(target);
            }
        }
    }

    render() {
        const { cardData, styleOut } = this.props;
        return (
            <div className={'list-card'} style={styleOut}>
                {
                    cardData.map((row, index) => {
                        return this.renderRow(row, index)
                    })
                }
            </div>
        )
    }

    getContent = (overTime, count) => {
        let message = ``;
        switch (true) {
            // case overTime >= 90:
            //     message =  `3个月及以上未发布(${count}个)`;
            //     break;
            // case overTime <= 30 && overTime > 7:
            //     message =  `一个月内未发布(${count}个)`;
            //     break;
            // case overTime <= 7 && overTime > 0:
            //     message =  `一周内未发布(${count}个)`;
            //     break;
            case overTime < 0:
                message = `从未发布或未采集到（${count}个）`
                break;
            default:
                message =  `${overTime}天及以上未发布（${count}个）`;
                // message =  `${overTime}天及以上未发布`;
                break;
        }
        return message;
    }
    // 渲染行
    renderRow = (row, index) => {
        const { isZombieCardData } = this.props;
        const { expandedRows } = this.state;
        const isExtended = expandedRows[row.positionTypeId] || false;
        let showData = row.child;
        if (!isExtended) {
            showData = row.child.slice(0, this.getColSpan())
        }
        let totalChildLength = row.child.length;
        if(isZombieCardData) {
            totalChildLength = row.child.map(item => item.child.length).reduce((a, b) => a + b);
        }
        return (
            <div key={row.positionTypeId}>
                <div><img alt={"账号logo"} src={row.logo} style={{
                    width: 20,
                    height: 20,
                    marginRight: 8,
                    verticalAlign: "bottom"
                    }}/>{row.positionTypeName}{`（${totalChildLength}个）`}
                </div>
                {isZombieCardData ? showData.map((item, index) => {
                    return (
                        <div key={index}>
                            <div style={{ color: item.overColor, marginTop:10 }}>{this.getContent(item.overTime, item.child.length)}</div>
                            <Row style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                                {item.child.map((col, index) => {
                                    return this.renderCol(col, index, item.overColor)
                                })
                                }
                            </Row>
                        </div>
                    )
                }) :
                    <Row style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                        {
                            showData.map((col, index) => {
                                return this.renderCol(col, index)
                            })
                        }
                    </Row>}
                {(row.child.length > this.getColSpan()) ?
                    <div style={{ textAlign: "center", cursor: "pointer" }}
                        onClick={() => this.clickExtend(row)}>{isExtended ? "收起" : "查看更多"}</div> : null}
            </div>
        )
    };

    clickExtend(row) {
        this.setState(prevState => ({
            expandedRows: {
                ...prevState.expandedRows,
                [row.positionTypeId]: !prevState.expandedRows[row.positionTypeId],
            },
        }));
    }

    cardMargin = 16;

    auditingStatusName = this.sysConfigGetValueByKey("position.manage.auditing.statusName", "提交至审核人,提交至宣传部,退回修改").split(",");

    //流程是否处在审核中
    isAuditInProgress(col) {
        if (!this.auditingStatusName || !col || !col.statusName || this.auditingStatusName.length === 0) {
            return false;
        }
        return this.auditingStatusName.indexOf(col.statusName) > -1;
    }
    // 将16禁止颜色值转为rgb
    hexToRgbObject(hex) {
        let s = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) =>
            r + r + g + g + b + b);
        s = s.substring(1).match(/.{2}/g);

        if (!s) {
            return { r: 0, g: 0, b: 0 }; // 如果转换失败，则返回黑色  
        }

        // 将每个两位的16进制数转换为十进制数，并返回对象  
        return {
            r: parseInt(s[0], 16),
            g: parseInt(s[1], 16),
            b: parseInt(s[2], 16)
        };
    }  

    // 渲染列
    renderCol = (col, index, overColor = '') => {
        let {r,g,b} = this.hexToRgbObject(overColor);
        let colWidth = (this.state.contentWidth && eval(`(${this.state.contentWidth} - ${this.getColSpan() * this.cardMargin}) / ${this.getColSpan()}`)) || "";
        if(overColor) {
            colWidth -=2;
        }
        const {clickItem, activityTypeData = []} = this.props;
        let showAnnualTime = activityTypeData.some(record => record.type === 4 && record.status === 1);
        let isShow = this.isAuditInProgress(col);
        let isFollow = col?.followIds?.length ? col.followIds.includes(window.currentUser.id) : false;
        return (
            <Col className={"colInfo"} key={index}
                style={{ margin: `16px ${this.cardMargin + "px"} ${this.cardMargin + "px"} 0`, border: overColor ? `1px solid ${overColor}` : "", borderRadius: "5px", backgroundColor: overColor ? `rgba(${r},${g}, ${b}, .1)` : "#fff" }}>
                <Card
                    hoverable={true}
                    onClick={() => clickItem(col)}
                    style={{
                        borderRadius: "5px",
                        width: colWidth,
                        backgroundColor: 'transparent',
                        position: "relative"
                    }}
                    onMouseEnter={() => {
                        if (!isFollow && document.getElementById(col.id)) {
                            document.getElementById(col.id).style.display = 'block';
                        }
                    }}
                    onMouseLeave={() => {
                        if (!isFollow && document.getElementById(col.id)) {
                            document.getElementById(col.id).style.display = 'none';
                        }
                    }}
                >
                    <Meta
                        avatar={
                            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                                <img style={{width: 48, height: 48, borderRadius: "50%", objectFit: "cover"}}
                                     src={col.logo}/>
                                {this.renderFollow(col, isFollow)}
                            </div>
                        }
                        title={
                            <div>
                                <div style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        position: "absolute",
                                        top: 2,
                                        right: 10,
                                        fontSize: 12,
                                        lineHeight: '20px'
                                    }}>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{color: getColorByActivityType(col.processType)}}>{isShow ? col.processName : ""}</div>
                                        {isShow && <div style={{
                                            width: 1,
                                            height: 11,
                                            border: '1px solid #9e9e9e',
                                            margin: '0 7px 0 8px'
                                        }}/>}
                                        <div title={col.statusName} style={{color: getColorByStatus(col.statusName)}}>{col.statusName}</div>
                                    </div>
                                </div>
                                <div style={{ display: "flex", alignItems: 'center' }}>
                                    <div title={col.name}
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            fontSize: 14,
                                            marginTop: 4,
                                            lineHeight: '24px',
                                            textAlign: 'left',
                                            color: "#000000d9",
                                            maxWidth: 115
                                        }}>
                                        {col.name}
                                    </div>
                                    <img style={{ marginLeft: 5, objectFit: "contain" }}
                                        src={col.status === "已备案" ? recorded : noRecord} alt="" />
                                </div>
                            </div>
                        }
                        description={
                            <div style={{color: "#00000073", fontSize: 12}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <div title={col.mainDeptName} style={{
                                        maxWidth: 100,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>{col.mainDeptName}</div>
                                </div>
                                {(showAnnualTime || overColor) &&
                                    <div style={{ height: 20, lineHeight: "20px" }}>
                                        {
                                            !overColor ? `最新年审时间：${col.annualAuditTime ? formatToDay(col.annualAuditTime) : "无"}` : `最新发布时间：${col.lastActiveTime ? formatToDay(col.lastActiveTime) : "无"}`
                                        }
                                    </div>}
                            </div>
                        }
                    />
                </Card>
                {this.renderActions(col)}
                <style>{`.colInfo .ant-card-body{position: relative}`}</style>
            </Col>
        )
    };

    renderActions(col, overColor = '') {
        const actions = this.getActions(col);
        return (
            <div className={"actions"} style={{
                display: "flex",
                justifyContent: "center",
                alignItems: 'center',
                borderRadius: "0px 0px 5px 5px",
                border: actions.length > 0 ? "1px solid #e8e8e8" : 0,
                borderTop: 0
            }}>
                {actions.map(item => item)}
                <style>{`
                .colInfo .ant-card{border-radius: ${actions.length > 0 ? "5px 5px 0px 0px !important" : "5px"};}
                .colInfo .actions:hover{border-color: rgba(0, 0, 0, 0.09);box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09)}
                `}</style>
            </div>
        )
    }

    renderFollow = (col, isFollow) => {
        const {typeData = []} = this.props;
        let typeItem = typeData.length && typeData.find(item => item.id === col.positionTypeId);
        return (<>
            {typeItem?.code === "gzh" &&
                <div style={{position: "absolute", bottom: 30, display: isFollow ? "block" : "none"}} id={col.id}>{isFollow
                    ? <span className='position-manage-followed' onMouseEnter={(e) => {
                        e.target.style.color = '#000';
                        e.target.style.background = '#f5f8fc';
                        e.target.innerText = '取消关注'
                    }} onMouseLeave={(e) => {
                        e.target.innerText = '已关注'
                        e.target.style.color = '#fff';
                        e.target.style.background = '#efad2a';
                    }} style={{color: "#fff", background: '#efad2a'}} onClick={(e) => {
                        e.stopPropagation();
                        this.followAccount(col.code, false)
                    }}>已关注</span> :
                    <span onMouseEnter={(e) => {
                        e.target.style.color = '#000';
                        e.target.style.background = '#f5f8fc';
                    }} className='position-manage-follow' onClick={(e) => {
                        e.stopPropagation();
                        this.followAccount(col.code, true)
                    }}>关注</span>}</div>}
        </>)
    }

    // 关注账号
    followAccount = (mediaCode, follow) => {
        const {refreshList} = this.props;
        this.request({
            url: '/cm-sites-media-consumer/position/content/manager/follow',
            method: 'post',
            body: {
                follow,
                mediaCode
            },
            callBack: () => {
                if (follow) {
                    message.success('关注成功');
                } else {
                    message.success('已取消关注');
                }
                refreshList();
            }
        })
    }

    getActions(col) {
        const { refreshList, clickItem } = this.props;
        let actions = [];
        let transferLimit = this.permissionCheck("pms:positionManage:transferPosition");//转交阵地按钮权限
        let historyPublishLimit = this.permissionCheck("pms:positionManage:historyPublish");
        let transferPositionAdmin = this.permissionCheck("pms:positionManage:transferPositionAdmin");
        let transferShowByStatus = this.sysConfigGetValueByKey("positionManage.transfer.status", "审核通过,草稿");
        let isCurrentUser = window.currentUser.id === col.belongUserAccount;  //是否当前用户
        let isCurrentDept = col.belongDeptId === window.currentUser?.defaultInfo?.dept?.id; //是否当前部门
        let isShowByStatusName = col.statusName && transferShowByStatus.indexOf(col.statusName) > -1;  //根据配置的流程状态确定是否展示转交按钮
        let allPermission = historyPublishLimit && ((transferLimit && isCurrentUser)||transferPositionAdmin) && isShowByStatusName;  //满足所有权限
        let width = allPermission ? "50%" : "100%";
        if (historyPublishLimit) {
            actions.push(<HistoricalRelease key={col.id + 'history'} item={col} styleOut={{
                width: width,
                height: 47,
                lineHeight: "47px",
                textAlign: "center",
                display: "inline-block",
                color: "#00000073"
            }} />)
        }
        if (allPermission) {
            actions.push(<div key={col.id + "div"} style={{ width: 1, height: 20, border: "1px solid #e8e8e8" }} />)
        }
        if (((transferLimit && isCurrentUser)||transferPositionAdmin) && isShowByStatusName) {
            actions.push(<TransferPosition key={col.id + "transfer"} refreshList={refreshList} item={col} styleOut={{
                width: width,
                height: 47,
                lineHeight: "47px",
                textAlign: "center",
                display: "inline-block",
                color: "#00000073"
            }} />)
        }
        if (col.processType === 5 && !isCurrentUser && isCurrentDept) {
            actions = [];
            actions.push(
                <GetPosition clickItem={clickItem} key={col.id + "linQu"} item={col} styleOut={{
                    width: width,
                    height: 47,
                    lineHeight: "47px",
                    textAlign: "center",
                    display: "inline-block",
                    color: "#00000073"
                }} />
            )
        }
        return actions;
    }

    getColSpan = () => {
        const screenWidth = this.state.contentWidth;
        if (screenWidth > 1576) {
            return 6;
        } else if (screenWidth <= 1576 && screenWidth >= 1403) {
            return 5;
        } else if (screenWidth <= 1403 && screenWidth >= 1200) {
            return 4;
        } else if (screenWidth <= 1200 && screenWidth >= 945) {
            return 3;
        } else if (screenWidth >= 762) {
            return 2;
        }
    };

}